import React from 'react';
import { useState, forwardRef } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import UpdateIcon from '@mui/icons-material/Update';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ETaskStatus } from '../../enums/task-status.enum';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import LockResetIcon from '@mui/icons-material/LockReset';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

interface IMoreVertPopoverProps {
  index: number;
  handleToDoBtn: () => void;
  handleInProgressBtn: () => void;
  handleOnHoldBtn: () => void;
  handleCompleteBtn: () => void;
  handleRequestBtn: () => void;
  isClosePopup: boolean;
  status: ETaskStatus;
}

const MoreVertPopover = forwardRef((props: IMoreVertPopoverProps, _ref) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    handleClose();
  }, [props.isClosePopup]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <MoreVertIcon
        id={'btn-edit-' + props?.index}
        onClick={handleClick}
        style={{
          fontSize: '17px',
          cursor: 'pointer',
          marginRight: '5px'
        }}
      />
      <Popover
        className="more-vert-popover"
        /* id={id} */
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
        <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
          <nav aria-label="main mailbox folders">
            <List>
              {props.status !== ETaskStatus.COMPLETED ? (
                <>
                  {props.status !== ETaskStatus.TO_DO && (
                    <ListItem disablePadding>
                    <ListItemButton onClick={() => props?.handleToDoBtn()}>
                      <ListItemIcon>
                        <PlaylistAddIcon style={{ fontSize: '22px' }} />
                      </ListItemIcon>
                      <ListItemText primary="To Do" />
                    </ListItemButton>
                  </ListItem>
                  )}
                  {props.status !== ETaskStatus.IN_PROGRESS && (
                    <ListItem disablePadding>
                    <ListItemButton onClick={() => props?.handleInProgressBtn()}>
                      <ListItemIcon>
                        <AutorenewIcon style={{ fontSize: '22px' }} />
                      </ListItemIcon>
                      <ListItemText primary="In Progress" />
                    </ListItemButton>
                  </ListItem>
                  )}
                  {props.status !== ETaskStatus.ON_HOLD && (
                    <ListItem disablePadding>
                    <ListItemButton onClick={() => props?.handleOnHoldBtn()}>
                      <ListItemIcon>
                        <LockResetIcon style={{ fontSize: '22px' }} />
                      </ListItemIcon>
                      <ListItemText primary="On Hold" />
                    </ListItemButton>
                  </ListItem>
                  )}
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => props?.handleCompleteBtn()}>
                      <ListItemIcon>
                        <DoneIcon style={{ fontSize: '22px' }} />
                      </ListItemIcon>
                      <ListItemText primary="Complete" />
                    </ListItemButton>
                  </ListItem>
                </>
              ) : (
                <ListItem disablePadding>
                  <ListItemButton onClick={() => props?.handleRequestBtn()}>
                    <ListItemIcon>
                      <UpdateIcon style={{ fontSize: '22px' }} />
                    </ListItemIcon>
                    <ListItemText primary="Status Change Request" />
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </nav>
        </Box>
      </Popover>
    </div>
  );
});

export default MoreVertPopover;
